import styled, { css } from "styled-components"
import { CursorCircleWhite, CursorCircleBlack } from "shared/Styles/Cursors"
export const HeroWrapper = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: #1c1c1c;
  ${props=>(props.mouseBlack ? CursorCircleBlack : CursorCircleWhite)}
  ${({ photoUrl }) =>
    photoUrl &&
    css`
      background-image: url(${photoUrl});
      background-repeat: no-repeat;
      background-position: center center;
      /* background-size: 100%; */
      object-fit: contain;
    `}
`

export const StyledVideo = styled.video`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  object-fit: fill;
  z-index: 1;
  filter: grayscale(0.8);
`
